import { IOfficeContent } from '../../planEatApi/PlanEatFacade';
import { Modal } from '../ui/Modal';
import { InputContainer } from '../ui/InputContainer';
import { CancelCrudButtons } from '../ui/CancelCrudButtons';
import { InputField } from '../ui/InputField';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme: any) => ({
    officeAdminId: {
        padding: 15,
        width: "100%",
       border: "1px grey solid",
       borderRadius: 8,
       marginBottom: 15
    },
    title: {
        fontSize: 20,
        fontWeight: 700,
        marginTop: 25,
        marginBottom: 10
    }, 
}));

interface Props {
    officeCreationModalHidden:boolean;
    setOfficeCreationModalHidden:  React.Dispatch<React.SetStateAction<any>>;
    office: IOfficeContent;
    setOffice:  React.Dispatch<React.SetStateAction<IOfficeContent>>;
    postOffice: () => void
}


export const OfficeCreationModal: React.FC<Props> = ({officeCreationModalHidden,setOfficeCreationModalHidden,office,setOffice,postOffice}) => {
    const classes = useStyles()

    const handleChange = (prop: keyof IOfficeContent) => (event: React.ChangeEvent<HTMLInputElement>) => {
        setOffice({ ...office, [prop]: event.target.value });
    };

    return (
        <Modal hidden={officeCreationModalHidden} setHidden={setOfficeCreationModalHidden} title={office.id !== '' ? "Update Office  " : "New Office  "} >
            <div>
                <InputContainer>
                    <InputField
                        label="Office Name"
                        variant="outlined"
                        multiline
                        value={office.officeName}
                        onChange={handleChange('officeName')}
                        fullWidth
                    />
                    <InputField
                        label="Office Address"
                        variant="outlined"
                        value={office.officeAddress}               
                        onChange={handleChange('officeAddress')}
                        fullWidth
                    />
                </InputContainer>
                <div>
                    <div className={classes.title}> Office admins</div>
                    {office.officeAdminIds.map(officeAdminId => 
                        <div className={classes.officeAdminId}>
                            {officeAdminId}
                        </div>
                    )}
                </div>

                <CancelCrudButtons 
                    hidden={officeCreationModalHidden} 
                    setHidden={setOfficeCreationModalHidden} 
                    postButtonText={office.id !== '' ? "Update" : "Create" + " Office"}
                    isDelete={false} 
                    postEntity={postOffice} />
            </div>
        </Modal>   
    );
}